//TODO: REFACTORING ALL PROJECT

import React, { useCallback, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AppRouter } from './components'
import { allLanguages } from './redux/reducers/language'
import { LanguageActionCreators } from './redux/reducers/language/action-creators'

import './styles/index.scss'

import { getQueryParams } from './utils/query'
import { BrowserTokenActionCreators } from './redux/reducers/browserToken/action-creators'

const App = () => {
  const dispatch = useDispatch()

  const ref = React.useRef(null)

  const [expired, setExpired] = React.useState(null)

  const changeLang = useCallback(() => {
    let langKey, language
    if (Object.keys(getQueryParams()).includes('language')) {
      language = getQueryParams().language
    } else {
      const lang = window.location.pathname.split('/')[2]
      if (allLanguages.includes(lang)) {
        language = lang
      }
    }

    if (!allLanguages.includes(language)) language = 'az'

    if (language === 'ru') {
      langKey = 'valueRu'
    } else if (language === 'en') {
      langKey = 'valueEn'
    } else {
      langKey = 'valueAz'
    }

    dispatch(LanguageActionCreators.changeLanguage(language, langKey))
  }, [dispatch])


  const generateBrowserToken = React.useCallback(async () => {
    try {
      const res = await dispatch(BrowserTokenActionCreators.getBrowserToken())
      if (res.status !== 200) {
        throw new Error()
      }
      const dateRefresh = Date.now() + 600000 - Date.now()

      if (ref.current) clearTimeout(ref.current)

      ref.current = setTimeout(() => {
        setExpired(true)
      }, dateRefresh)
    } catch (error) {}
  }, [dispatch])

  useEffect(() => {
    if (!expired) return
    ;(async () => {
      if (expired) {
        setExpired(null)
        clearTimeout(ref.current)
        generateBrowserToken()
      }
    })()
  }, [generateBrowserToken, expired])

  useEffect(() => {
    // generateBrowserToken()
  }, [generateBrowserToken])

  useEffect(() => {
    changeLang()
  }, [changeLang])

  return <AppRouter />
}

export default App
